<template>
  <v-card>
    <v-card-title>
      <v-layout align-center>
        <v-flex> Check-in & Check-out performance ({{ dialogdata.adminid }}) </v-flex>
        <v-flex shrink class="text-xs-right">
          <v-btn icon @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <!-- <div>
      <v-layout row wrap>
        <v-flex xs6>
          <v-card class="pa-2 mr-1">
            <div class="primary--text" style="font-weight: bold">Average Check-in time</div>
            <div>{{ avgcheckin }}</div>
          </v-card>
        </v-flex>
        <v-flex xs6>
          <v-card class="pa-2 ml-1">
            <div class="primary--text" style="font-weight: bold">Average Check-out time</div>
            <div>{{ avgcheckout }}</div>
          </v-card>
        </v-flex>
      </v-layout>
    </div> -->
      <DateFilter
        v-model="selectedDate"
        :default-filter="'last_3_days'"
        @changeDate="handleChangeDate"
      ></DateFilter>
      <div class="mt-3">
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="data"
          class="elevation-1"
          :pagination.sync="pagination"
          :total-items="total"
        >
          <template #items="props">
            <tr>
              <td>
                {{ props.item.checkin | DateFormat('DD/MM/YYYY HH:mm') }}
              </td>
              <td>
                {{ props.item.checkout | DateFormat('DD/MM/YYYY HH:mm') }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import moment from 'moment'
import ticket3AgentManagementApi from '@/api/ticket3/agent-management'
import { handleApiError } from '@/api/util'

export default {
  components: {
    DateFilter
  },
  props: ['dialogdata'],

  data() {
    return {
      avgcheckin: '-',
      avgcheckout: '-',
      data: [],
      pagination: { rowsPerPage: 10 },
      headers: [
        { text: 'Check-in time', value: 'checkin', sortable: false },
        { text: 'Check-out time', value: 'checkout', sortable: false }
      ],
      loading: false,
      selectedDate: {
        start: moment().subtract(3, 'days').format('YYYY-MM-DD 00:00'),
        end: moment().format('YYYY-MM-DD 23:59')
      },
      total: 0
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  watch: {
    pagination: {
      handler() {
        this.handleGetCheckInCheckOutHistory()
      },
      deep: true
    }
  },
  methods: {
    getAverageTime(times) {
      const count = times.length
      var timesInSeconds = []
      // loop through times
      for (let i = 0; i < count; i++) {
        // parse
        var pieces = times[i].split(':')
        var ampm = pieces[2].split(' ')
        var hrs = Number(pieces[0])
        var mins = Number(pieces[1])
        var secs = Number(ampm[0])
        ampm = ampm[1]
        // convert to 24 hr format (military time)
        if (ampm == 'PM') hrs = hrs + 12
        // find value in seconds of time
        var totalSecs = hrs * 60 * 60
        totalSecs += mins * 60
        totalSecs += secs
        // add to array
        timesInSeconds[i] = totalSecs
      }
      // find average timesInSeconds
      var total = 0

      for (var j = 0; j < count; j++) {
        total = total + Number(timesInSeconds[j])
      }
      var avg = Math.round(total / count)
      // console.log('avg secs: ' + avg)
      // turn seconds back into a time
      var avgMins = Math.floor(avg / 60)
      var avgSecs = avg - 60 * avgMins
      var avgHrs = Math.floor(avgMins / 60)
      // console.log('hours: ' + avgHrs)
      avgMins = avgMins - 60 * avgHrs
      // convert back to 12 hr. format
      var avgAmpm = 'AM'
      if (avgHrs > 12) {
        avgAmpm = 'PM'
        avgHrs = avgHrs - 12
      }
      // add leading zeros for seconds, minutes
      avgSecs = ('0' + avgSecs).slice(-2)
      avgMins = ('0' + avgMins).slice(-2)
      // your answer
      return avgHrs + ':' + avgMins + ':' + avgSecs + ' ' + avgAmpm
    },
    handleChangeDate() {
      if (this.pagination.page !== 1) {
        this.pagination.page = 1
      } else {
        this.handleGetCheckInCheckOutHistory()
      }
    },
    async handleGetCheckInCheckOutHistory() {
      const { page, rowsPerPage } = this.pagination
      const data = {
        page_id: this.selectedBot.pageid,
        admin_id: this.dialogdata.adminid,
        start_date: this.selectedDate.start, // YYYY-MM-DD
        end_date: this.selectedDate.end, // YYYY-MM-DD
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage
      }

      this.loading = true
      try {
        const response = await ticket3AgentManagementApi.getAgentPerformanceCheckInCheckOutHistory({
          params: data
        })
        this.loading = false
        if (response.status == 200) {
          this.data = response.data.data.map((el) => {
            return {
              checkin: el.check_in_timestamp,
              checkout: el.check_out_timestamp
            }
          })
          this.total = response.data.total || 0
          // const checkintimes = this.data.map((el) => {
          //   if (el.checkin) {
          //     return moment(el.checkin, 'h:mm:ss A').format('h:mm:ss A')
          //   } else return null
          // })
          // const checkouttimes = this.data.map((el) => {
          //   if (el.checkout) {
          //     return moment(el.checkout, 'h:mm:ss A').format('h:mm:ss A')
          //   } else return null
          // })
          // this.avgcheckin = this.getAverageTime(checkintimes.filter((el) => el))
          // this.avgcheckin = moment(this.avgcheckin, 'h:mm:ss A').format('HH:mm')
          // this.avgcheckout = this.getAverageTime(checkouttimes.filter((el) => el))
          // this.avgcheckout = moment(this.avgcheckout, 'h:mm:ss A').format('HH:mm')
        } else {
          this.data = []
          this.total = 0
        }
      } catch (error) {
        handleApiError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/agents/Performance/DialogAgent.vue